import * as Yup from 'yup'

const sellerInventoryBatchRejectItemSchema = Yup.object().shape({
  reject_reason: Yup.string().required('Required')
})

export default sellerInventoryBatchRejectItemSchema